import clinicalTrialsConfig from "./clinicalTrialsConfig";
import companyConfig from "./companyConfig";
import fda510kConfig from "./fda510kConfig";
import fdaDenovoConfig from "./fdaDenovoConfig";
import fdaDrugsConfig from "./fdaDrugsConfig";
import fdaPmaConfig from "./fdaPmaConfig";
import googlePatentsConfig from "./googlePatentsConfig";
import pubmedConfig from "./pubmedConfig";

const datasetConfigs = {
  clinical_trials: clinicalTrialsConfig,
  company: companyConfig,
  pubmed: pubmedConfig,
  fda_510k: fda510kConfig,
  fda_denovo: fdaDenovoConfig,
  fda_pma: fdaPmaConfig,
  fda_drugs: fdaDrugsConfig,
  google_patents: googlePatentsConfig,
};

export default datasetConfigs;
